export const CATS = {
  REALTY: "Житло та нерухомість",
  TRANSPORT: "Транспорт",
  GADGETS: "Гаджети",
  CAREER: "Карʼєра",
  SERVICES: "Майстри та послуги",
  HOME: "Дім та затишок",
  GARDEN: "Для саду та подвір'я",
  KIDS: "Малеча",
  PETS: "Домашні улюбленці",
  FASHION: "Стиль",
  SPORT: "Активність та спорт",
  BEAUTY: "Б’юті",
  EDU: "Знання та Навчання",
  RENT: "Оренда та прокат",
  PARTS: "Запчастини та аксесуари",
  ACCESSORIES: "Аксесуари",
  FOOD: "Продукти та їжа",
  HOBBY: "Хобі",
};

export const PROFS = [
  "психолог","психотерапевт","психіатр","коуч","ментор","консультант","логопед",
  "лікар","медик","терапевт","стоматолог","ортодонт","педіатр","кардіолог","гінеколог","масажист","реабілітолог","дієтолог",
  "юрист","адвокат","нотаріус","параюрист","правник","медіатор",
  "плиточник","плиточн","штукатур","маляр","електрик","сантехнік","зварювальник","столяр",
  "монтажник","покрівельник","віконник","збірщик","укладальник","клінер","клінінг","хімчистк",
  "манікюр","педикюр","майстер нігт","бровист","лешмейкер","візаж","перукар","барбер","колорист","косметолог","ламінуван",
  "репетитор","вчитель","тьютор","тренер","фітнес-тренер","інструктор","йога","пилатес",
  "дизайнер","дизайн","графдиз","ux","ui","product-диз","інтерʼєр","копірайтер","сценарист",
  "смм","smm","таргетолог","маркетолог","seo","ppc","контекстолог","фотограф","відеограф","оператор","монтажер",
  "програміст","розробник","frontend","backend","fullstack","qa","тестувальник","адміністратор","devops",
  "курʼєр","курьер","водій","водит","уборщ","няня","доглядальниц","повар","офіціант","бариста","адміністратор"
];

export const NOUNS = {
  [CATS.REALTY]: [
    "квартир","апартам","апарт","жк","житл","будин","котедж","таунхаус","дуплекс","дач",
    "ділянк","земл","гараж","паркінг","складськ","офіс","комерц","магазин","цех","ангар",
    "мансард","балкон","лоджі","терас","пентхаус","новобуд","вторинк","панел","цегл","моноліт"
  ],
  [CATS.RENT]: [
    "оренд","прокат","подобов","погодин","довгострок","короткострок","здам","зніму","здаєть",
    "rent","lease"
  ],
  [CATS.TRANSPORT]: [
    "авто","машин","легков","вантаж","мото","скутер","самокат","електромоб","велосипед","вел",
    "кросовер","седан","хетчбек","універсал","кабріолет","квадроцик","яхт","катер","човн","бус","мікроавтобус"
  ],
  [CATS.GADGETS]: [
    "смартфон","телефон","айфон","iphone","андроїд","android","ноутбук","лептоп","пк","комп","планшет",
    "телевізор","монітор","камера","фотоапарат","навушник","роутер","модем","ssd","жорстк","хард"
  ],
  [CATS.CAREER]: [
    "ваканс","робот","посад","зарплат","резюме","найм","офер","карʼєр","карєр","графік","стажуван"
  ],
  [CATS.SERVICES]: [
    "послуг","майстр","виклик","виїзд","заявк","замір","кошторис","прайс","портфоліо","сертифікат","сертифікован",
    ...PROFS
  ],
  [CATS.HOME]: [
    "мебл","шаф","ліжк","диван","комод","тумб","стіл","стільц",
    "пилосос","холодил","пральн","посудомий","мікрохвильов","чайник",
    "декор","торшер","дзеркал","картини","текстиль","свічк","постіль","кили"
  ],
  [CATS.GARDEN]: [
    "сад","садов","город","рослин","квіт","горщик","саджан","парник","теплиц","полив","шланг",
    "газонокос","триммер","мотокос","бочка","душ","навіс","сарай","клумб","грядк","компостер",
    "альтанк","бесідк","пергол","гойдалк","качел","мангал","барбекю"
  ],
  [CATS.KIDS]: [
    "дитяч","немовля","візоч","коляск","іграш","конструктор","lego","одяг дит","повзунк","автокріс","стільчик для годуван","манеж"
  ],
  [CATS.PETS]: [
    "собак","пес","цуцен","кот","кітк","кошен","папуг","акваріум","рибк","гризун","хомʼяк","шиншил","кролик",
    "повідок","будк","лоток","корм","амуніці"
  ],
  [CATS.FASHION]: [
    "одяг","взутт","сумк","рюкзак","футболк","джинс","спідниц","сукн","светр","куртк","пальт","піджак","жилет","худі","легінс","білизн"
  ],
  [CATS.SPORT]: [
    "спорт","кросівк","штанг","гантел","тренаж","велотренаж","ракетк","мʼяч","намет","захист","шолом","ленти опор","каремат"
  ],
  [CATS.BEAUTY]: [
    "космет","макіяж","туш","помад","скраб","крем","догляд","епілятор","лампа для нігтів","гел-лак","геллак","шампун","кондиціонер","фарба для волос"
  ],
  [CATS.EDU]: [
    "книга","підручн","курс","лекц","зно","репетитор","словник","навчан","освіт","університет","аудіокниг"
  ],
  [CATS.PARTS]: [
    "запчаст","шини","покришк","гума","диски","масло","фільтр","бампер","стартер","генератор","компресор","коробк","двигун","кузов","тормозн","гальм"
  ],
  [CATS.ACCESSORIES]: [
    "аксесуар","окуляр","сонцезахисн окуляр","ремін","ремінець","браслет","ланцюж","кулон","підвіс","сережк","кільц","перстен","запонк",
    "годинник","кепк","панам","капелюх","шарф","рукавичк","пояс","портмоне","гаманець","карта тримач"
  ],
  [CATS.FOOD]: [
    "їжа","продукт","випічк","хліб","мʼяс","ковбас","сир","молок","варенн","джем","мед","солін","ягод","фрукт","овоч",
    "готова їжа","страва","кейтеринг","торт","пиріг","печив","соус"
  ],
  [CATS.HOBBY]: [
    "настільн","пазл","вʼязан","вишивк","рукоділ","малюван","фарб","гітар","синтезатор","глина","дрон",
    "моделюван","орігамі","origami","шитт","бісер","скрапбукінг","картини за номерам"
  ],
};

export const VERBS = {
  BUY:  ["куп","придба","візьму"],
  SELL: ["прод","реаліз"],
  RENT: ["оренд","знім","здам","здаєть","rent","lease","прокат"],
  GIVE: ["віддам","безкоштовно","даром","безплат"],
  EXCH: ["обмін","поміняю","міняю","swap","trade"],
  SEARCH:["шука","потрібн","цікавить","хочу"],
  HIRE:  ["ваканс","шукаємо","потрібен","потрібна","найм","офіційне","офіційна","зарплат","графік","резюме","стажуван","офер"],
  OFFER: ["надаю","надам","виконаю","зроблю","майстер","послуги","виїзд","виклик","портфоліо","прайс","замовлення","приватно","фріланс","фриланс"],
};

export const WEIGHTS = {
  nounHit: 3,
  verbBuySell: 2,
  verbRent: 5,
  miscBoost: 1,
  profHit: 3,
  hireBoost: 5,
  offerBoost: 5,
};

export const REALTY_HINTS = [
  /\b\d+\s?м2?\b/,"м2","м²","квадрат","жк","балкон","лодж","терас","мансард","1к","2к","3к","однуш","двуш","трьош"
];
